import { render, staticRenderFns } from "./RegionsEdit.vue?vue&type=template&id=510a2bec"
import script from "./RegionsEdit.vue?vue&type=script&lang=js"
export * from "./RegionsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports